module.exports = __webpack_public_path__ + "img/widgetabout-3.7590a44f.jpg";